import { headerHeight, throttle } from './helpers'

let videos = []

export default elements => (videos = elements)

const onScroll = () => {
  const maxY = headerHeight() || 100
  const y = window.scrollY || document.documentElement.scrollTop
  videos.forEach(video => {
    if (y > maxY) {
      video.pause()
    } else {
      video.play()
    }
  })
}

window.addEventListener('scroll', throttle(onScroll, 100))
